import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useOrderAfterSalesApply = (orderId: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  const { set: setError } = useApiError();
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useOrderAfterSalesApply-${orderId}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useOrderAfterSalesApply-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useOrderAfterSalesApply-error-${orderId}`);

  // 发起支付
  const afterSaleApply = async (customQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.orderAfterSalesApply(customQuery);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value = null;
      } else {
        setError({ code: res.code, message: res.message });
        error.value = res.message;
        result.value = null;
      }
    } catch (err) {
      error.value = err.message;
      result.value = null;

    } finally {
      loading.value = false;
    }
  };

  return {
    afterSaleApply: afterSaleApply,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
